"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCommonCommands = void 0;
var CheckAccountHolderDetailsMatchCommand_1 = require("./CheckAccountHolderDetailsMatchCommand");
var CheckAdditionalDriverAnyVehicleCommand_1 = require("./CheckAdditionalDriverAnyVehicleCommand");
var CheckExpiredQuoteCommand_1 = require("./CheckExpiredQuoteCommand");
var CheckNavigateToNewCardCommand_1 = require("./CheckNavigateToNewCardCommand");
var CheckUserEmailEqualityCommand_1 = require("./CheckUserEmailEqualityCommand");
var ClearCacheCommand_1 = require("./ClearCacheCommand");
var ClearUnderwritingRulesCommand_1 = require("./ClearUnderwritingRulesCommand");
var ConvertToUppercaseCommand_1 = require("./ConvertToUppercaseCommand");
var DeclineOnUwFailureCommand_1 = require("./DeclineOnUwFailureCommand");
var GoBackCommand_1 = require("./GoBackCommand");
var LoadClassifiersCommand_1 = require("./LoadClassifiersCommand");
var LogOutCommand_1 = require("./LogOutCommand");
var NavigateAfterSettlePayment_1 = require("./NavigateAfterSettlePayment");
var NavigateIfUwPresentCommand_1 = require("./NavigateIfUwPresentCommand");
var NavigateToJourneyPage_1 = require("./NavigateToJourneyPage");
var NavigateToJourneyStatePage_1 = require("./NavigateToJourneyStatePage");
var RegisterOrLoginUnauthenticatedCommand_1 = require("./RegisterOrLoginUnauthenticatedCommand");
var ScrollToJourneyStatePageId_1 = require("./ScrollToJourneyStatePageId");
var SessionStorageSetItemCommand_1 = require("./SessionStorageSetItemCommand");
var SessionStorageRemoveItemCommand_1 = require("./SessionStorageRemoveItemCommand");
var SetCustomerEmail_1 = require("./SetCustomerEmail");
var SetSessionStorageForSuccessModal_1 = require("./SetSessionStorageForSuccessModal");
var SetValueToJourneyState_1 = require("./SetValueToJourneyState");
var TrimCommand_1 = require("./TrimCommand");
var ValidatePageCommand_1 = require("./ValidatePageCommand");
var SetDefaultMarketingPreferences_1 = require("./SetDefaultMarketingPreferences");
var ClearQuestionsValidationCommand_1 = require("./ClearQuestionsValidationCommand");
var ValidateUnansweredQuestionsCommand_1 = require("./ValidateUnansweredQuestionsCommand");
var LogMessageCommand_1 = require("./LogMessageCommand");
var VerifyAuthAndSetUserRefCommand_1 = require("./VerifyAuthAndSetUserRefCommand");
var SaveSessionStorageItemToInteractionCommand_1 = require("./SaveSessionStorageItemToInteractionCommand");
var AgreeToTermsCommand_1 = require("./annual/motor/AgreeToTermsCommand");
var SetDefaultMotorCoverTier_1 = require("./SetDefaultMotorCoverTier");
var SetPolicyPerformRenewalFlagCommand_1 = require("./SetPolicyPerformRenewalFlagCommand");
var RemoveSpecificInteractionChangesCommand_1 = require("./RemoveSpecificInteractionChangesCommand");
var AddSpecificInteractionChangesCommand_1 = require("./AddSpecificInteractionChangesCommand");
var addCommonCommands = function (extensions) {
    extensions.journeyComponents.addCommand({
        id: "checkAccountHolderDetailsMatch",
        component: CheckAccountHolderDetailsMatchCommand_1.CheckAccountHolderDetailsMatchCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkAdditionalDriverAnyVehicle",
        component: CheckAdditionalDriverAnyVehicleCommand_1.CheckAdditionalDriverAnyVehicleCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkExpiredQuote",
        component: CheckExpiredQuoteCommand_1.CheckExpiredQuoteCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkNavigateToNewCard",
        component: CheckNavigateToNewCardCommand_1.CheckNavigateToNewCardCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkUserEmailsEquality",
        component: CheckUserEmailEqualityCommand_1.CheckUserEmailEqualityCommand
    });
    extensions.journeyComponents.addCommand({
        id: "clearCache",
        component: ClearCacheCommand_1.ClearCacheCommand
    });
    extensions.journeyComponents.addCommand({
        id: "clearUnderwritingRules",
        component: ClearUnderwritingRulesCommand_1.ClearUnderwritingRulesCommand
    });
    extensions.journeyComponents.addCommand({
        id: "convertToUppercase",
        component: ConvertToUppercaseCommand_1.ConvertToUppercaseCommand
    });
    extensions.journeyComponents.addCommand({
        id: "declineOnUwFailure",
        component: DeclineOnUwFailureCommand_1.DeclineOnUwFailureCommand
    });
    extensions.journeyComponents.addCommand({
        id: "goBack",
        component: GoBackCommand_1.GoBackCommand
    });
    extensions.journeyComponents.addCommand({
        id: "loadClassifiers",
        component: LoadClassifiersCommand_1.LoadClassifiersCommand
    });
    extensions.journeyComponents.addCommand({
        id: "logOut",
        component: LogOutCommand_1.LogOutCommand
    });
    extensions.journeyComponents.addCommand({
        id: "navigateAfterSettlePayment",
        component: NavigateAfterSettlePayment_1.NavigateAfterSettlePayment
    });
    extensions.journeyComponents.addCommand({
        id: "navigateIfUwPresent",
        component: NavigateIfUwPresentCommand_1.NavigateIfUwPresentCommand
    });
    extensions.journeyComponents.addCommand({
        id: "navigateToJourneyPage",
        component: NavigateToJourneyPage_1.default
    });
    extensions.journeyComponents.addCommand({
        id: "navigateToJourneyStatePage",
        component: NavigateToJourneyStatePage_1.NavigateToJourneyStatePage
    });
    extensions.journeyComponents.addCommand({
        id: "registerUnauthenticated",
        component: RegisterOrLoginUnauthenticatedCommand_1.RegisterOrLoginUnauthenticatedCommand
    });
    extensions.journeyComponents.addCommand({
        id: "scrollToJourneyStatePageId",
        component: ScrollToJourneyStatePageId_1.ScrollToJourneyStatePageId
    });
    extensions.journeyComponents.addCommand({
        id: "sessionStorageSetItem",
        component: SessionStorageSetItemCommand_1.SessionStorageSetItemCommand
    });
    extensions.journeyComponents.addCommand({
        id: "saveSessionStorageItemToInteraction",
        component: SaveSessionStorageItemToInteractionCommand_1.SaveSessionStorageItemToInteractionCommand
    });
    extensions.journeyComponents.addCommand({
        id: "sessionStorageRemoveItem",
        component: SessionStorageRemoveItemCommand_1.SessionStorageRemoveItemCommand
    });
    extensions.journeyComponents.addCommand({
        id: "setCustomerEmail",
        component: SetCustomerEmail_1.SetCustomerEmail
    });
    extensions.journeyComponents.addCommand({
        id: "setSessionStorageForSuccessModal",
        component: SetSessionStorageForSuccessModal_1.SetSessionStorageForSuccessModal
    });
    extensions.journeyComponents.addCommand({
        id: "setValueToJourneyState",
        component: SetValueToJourneyState_1.SetValueToJourneyState
    });
    extensions.journeyComponents.addCommand({
        id: "trim",
        component: TrimCommand_1.TrimCommand
    });
    extensions.journeyComponents.addCommand({
        id: "validatePage",
        component: ValidatePageCommand_1.ValidatePageCommand
    });
    extensions.journeyComponents.addCommand({
        id: "validateUnansweredQuestions",
        component: ValidateUnansweredQuestionsCommand_1.ValidateUnansweredQuestionsCommand
    });
    extensions.journeyComponents.addCommand({
        id: "setMarketingPreferences",
        component: SetDefaultMarketingPreferences_1.SetDefaultMarketingPreferences
    });
    extensions.journeyComponents.addCommand({
        id: "setDefaultMotorCoverTier",
        component: SetDefaultMotorCoverTier_1.SetDefaultMotorCoverTier
    });
    extensions.journeyComponents.addCommand({
        id: "clearQuestionsValidation",
        component: ClearQuestionsValidationCommand_1.ClearQuestionsValidationCommand
    });
    extensions.journeyComponents.addCommand({
        id: "logMessage",
        component: LogMessageCommand_1.LogMessageCommand
    });
    extensions.journeyComponents.addCommand({
        id: "verifyAuthAndSetUserRef",
        component: VerifyAuthAndSetUserRefCommand_1.VerifyAuthAndSetUserRefCommand
    });
    extensions.journeyComponents.addCommand({
        id: "agreeToTerms",
        component: AgreeToTermsCommand_1.AgreeToTermsCommand
    });
    extensions.journeyComponents.addCommand({
        id: "setPolicyPerformRenewalFlag",
        component: SetPolicyPerformRenewalFlagCommand_1.SetPolicyPerformRenewalFlagCommand
    });
    extensions.journeyComponents.addCommand({
        id: "removeChanges",
        component: RemoveSpecificInteractionChangesCommand_1.RemoveSpecificInteractionChangesCommand
    });
    extensions.journeyComponents.addCommand({
        id: "addChanges",
        component: AddSpecificInteractionChangesCommand_1.AddSpecificInteractionChangesCommand
    });
};
exports.addCommonCommands = addCommonCommands;
//# sourceMappingURL=index.js.map